<script setup>
import { ref } from 'vue'
import { getLocalValue } from './../../common/utils/storage'
import axios from 'axios'

import { useCoreUserStore } from './../stores/CoreStore'

import ButtonVue from './ButtonCompVue'
import PasswordInputVue from './PasswordInputVue'
import TextInputVue from './TextInputVue'
import LoadingWidget from './LoadingWidget' 

const props = defineProps({
  alignment: {
    type: String,
    default: 'vertical',
  },
  authCheck: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['auth:check', 'login:success', 'logout:success'])

const coreUser = useCoreUserStore()
const user = coreUser.getUser

const loginBtn = ref()
const usernameInput = ref()
const passwordInput = ref()

const username = ref('')
const password = ref('')
//const pageLoaded = ref(false)
const authenticated = ref(props.authCheck)
const hasError = ref(false)
const btnSize = (props.alignment === 'vertical') ? 'btn-full-width' : 'btn-small'

const clearErrors = () => {
  usernameInput.value.toggleError()
  passwordInput.value.toggleError()
  hasError.value = false
}

const submitLoginCreds = () => {
  clearErrors()
  if (!username.value) {
    usernameInput.value.toggleError()
  }
  if (!password.value) {
    passwordInput.value.toggleError()
  }

  loginBtn.value.toggleSpinner(true)
  const data = {
    username: username.value,
    password: password.value,
  }
  return coreUser.login(data).then((r) => {
    emit('login:success')
    authenticated.value = true
    return r
  }).catch(err => {
    hasError.value = true
    loginBtn.value.toggleSpinner()
    return err
  })
}

/*const checkAuthentication = () => {
  if (getLocalValue('at')) {
    axios.defaults.headers.common['Authorization'] = `Token ${getLocalValue('at')}`

    coreUser.checkToken().then(
      res => {
        authenticated.value = true
      },
      err => {
        console.error(err)
      }
    ).finally(() => {
      emit('auth:check', authenticated.value)
      pageLoaded.value = true
    })
  } else {
    pageLoaded.value = true
    emit('auth:check', authenticated.value)
  }
}*/

const logout = () => {
  coreUser.logout().then(
    () => {
      authenticated.value = false
      emit('logout:success')
    },
    err => {
      console.error(err)
    }
  )
}

</script>

<template>
  <div class="login-widget-cont">
    <!--div class="login-wrapper" v-if="!pageLoaded">
      <LoadingWidget />
    </div-->

    <div class="login-wrapper" :class="props.alignment" v-if="!authenticated">
      <div class="input-wrapper">
        <TextInputVue
          ref="usernameInput"
          cssClasses="username-cont"
          inputName="username"
          placeholder="Username"
          :labelAsPlaceholder="true"
          v-model="username"
          @keyup.enter="submitLoginCreds">
        </TextInputVue>

        <PasswordInputVue
          ref="passwordInput"
          cssClasses="password-cont"
          inputName="password"
          placeholder="Password"
          :labelAsPlaceholder="true"
          inputType="password"
          v-model="password"
          @keyup.enter="submitLoginCreds">
        </PasswordInputVue>

        <ButtonVue
          ref="loginBtn"
          :size="btnSize"
          type="outline"
          label="Login"
          @btn-click="submitLoginCreds"
          @keyup-enter="submitLoginCreds"
        >
        </ButtonVue>
      </div>
      
      <div class="error-cont" ref="errorCont" v-show="hasError">
        <div class="error-msg">Invalid Credentials</div>
      </div>
    </div>

    <div class="username-wrapper flex align-center" v-else>
      <!-- TODO add logout btn, more user info? -->
      <div class="username strong-text">{{ user.username }}</div>
      <ButtonVue
        ref="logoutBtn"
        size="btn-small"
        type="outline"
        label="Logout"
        @btn-click="logout">
      </ButtonVue>
    </div>
  </div>
</template>

<style lang="scss">
.login-widget-cont {
  padding: $paddingSmall;

  .login-wrapper {

    &.vertical {
      .input-wrapper {
        margin-right: $marginSmall;

        .form-control-wrapper {

          &:not(:last-child) {
            margin-bottom: $marginSmall;
          }
        }
      }
    }

    &.horizontal {
      .input-wrapper{
        display: flex;
        align-items: center;
        
        .form-control-wrapper {
          margin: 0;
          margin-right: $marginSmall;
        }
      }
    }
  }

  .username-wrapper {
    .btn-cont { 
      margin-left: $margin;
    }
  }
}
</style>
